import { asScaled } from '../utils';
const navBarLayOut = {
    arrowMargin: 4,
    height: 44,
    // 标题左右留空20
    titleMargin: 20,
    buttonSize: {
        width: 44,
        height: 44,
        padding: 12
    }
};
const navBarLayOutScaled = asScaled(navBarLayOut);
export const navbar = {
    scaled: navBarLayOutScaled,
    unscaled: navBarLayOut
};
